<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Michelle Graham has been writing children’s stories, blogs, and pieces for comedy websites for several years. <em>The Adventures of the Karillapig</em> has been developed over a number of years. As a child, Michelle, along with her sister Debbie, made up stories about fictional characters, and so was born ‘The Karillapig’. In her day job, Michelle is a tutor and specialises in subjects around employment law and health and safety.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0af9bf9e